import React from 'react'
import { useNavigate } from 'react-router-dom'
const Contact = () => {
  const Navigate = useNavigate()
  const hadleSubmit = () => {
    alert('you  successfully Registered')
    Navigate('/')
  }
  return (
    <div className='container mt-5'>
      <div className='row'>
        <div className=' col-lg-8'>
          <form className='mt-4 p-5 jumbotron' onSubmit={hadleSubmit}>
            <h3>Registration Form</h3>
            <div className="form-group ">
              <label >Email address</label>
              <input type="email" className="form-control" required placeholder="Enter email" />

            </div>
            <div className="form-group">
              <label >Password</label>
              <input type="password" required className="form-control" placeholder="Password" />
            </div>

            <button type="submit" className="btn btn-primary">Submit</button>
          </form>
        </div>
        {/* card col */}
        <div className='col-lg-4 mt-5'>
          <div className="card contact-card">
            <div className="card-header">
              General Manager
            </div>
            <div className="card-body">
              <h5 className="card-title">Sohail Khan</h5>
              <p className="card-text">Contact Number +971569003156.</p>

            </div>

          </div>
          <hr />
          {/* card 2 */}
          <div className="card  contact-card">
            <div className="card-header">
              Operational Manager
            </div>
            <div className="card-body">
              <h5 className="card-title">fawad Khan</h5>
              <p className="card-text">Contact Number +971563099584 .</p>

            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact